import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { initialFiledFunc } from "../../components/Common/validationFunction";
import { C_Button } from "../../components/Common/CommonButton";
import { C_DatePicker } from "../../CustomValidateForm";
import * as _cfunc from "../../components/Common/CommonFunction";
import { mode, pageId, url } from "../../routes/index";
import { MetaTags } from "react-meta-tags";
import Select from "react-select";
import {
    BreadcrumbShowCountlabel,
    commonPageField,
    commonPageFieldSuccess,
    getpdfReportdataSuccess,
} from "../../store/actions";
import { customAlert } from "../../CustomAlert/ConfirmDialog";
import { ExcelReportComponent } from "../../components/Common/ReportCommonFunc/ExcelDownloadWithCSS";
import { allLabelWithZero, selectLabelWithZero } from "../../components/Common/CommonErrorMsg/HarderCodeData";
import {
    Loyalty_Claim_GoButton_Success,
    Loyalty_Claim_Report_Action,
} from "../../store/Report/LoyaltyClaimRedux/action";
import * as report from "../../Reports/ReportIndex";
import C_Report from "../../components/Common/C_Report";
import { setLoyaltyReportMode } from "./PDFReport/page";
import { getTableConfig } from "./PDFReport/TableData";
// 🟢 Global variables to hold selected dates
export let globalSelectedMonth = null;

const LoyaltyClaim = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const currentDate_ymd = _cfunc.date_ymd_func(localStorage.getItem("realTime"));
    const isSCMParty = _cfunc.loginIsSCMParty();

    const fileds = {
        FromDate: currentDate_ymd,
        ToDate: currentDate_ymd,
    };

    const [subPageMode] = useState(history.location.pathname);
    const [state, setState] = useState(() => initialFiledFunc(fileds));
    const [userPageAccessState, setUserAccState] = useState("");
    const [PartyDropdown, setPartyDropdown] = useState(allLabelWithZero);
    const [selectedMode, setSelectedMode] = useState(selectLabelWithZero);
    const [selectedMonth, setSelectedMonth] = useState(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
    });


    const {
        userAccess,
        tableData = "",
        GoBtnLoading,
        Distributor,
        pageField,
    } = useSelector((state) => ({
        tableData: state.LoyaltyClaimReducer.Loyalty_Claim_Gobtn,
        GoBtnLoading: state.LoyaltyClaimReducer.goBtnLoding,
        Distributor: state.CommonPartyDropdownReducer.commonPartyDropdownOption,
        supplier: state.CommonAPI_Reducer.vendorSupplierCustomer,
        userAccess: state.Login.RoleAccessUpdateData,
        pageField: state.CommonPageFieldReducer.pageField,
    }));

    const { Data = [], Type } = tableData;
    const values = { ...state.values };

    // 🟢 Load initial data
    useEffect(() => {
        let pageID;
        if (subPageMode === url.LOYALTY_CLAIM_REPORT) {
            pageID = pageId.LOYALTY_CLAIM_REPORT;
        } else {
            pageID = pageId.LOYALTY_CLAIM_REPORT;
        }
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(pageID));
        dispatch(BreadcrumbShowCountlabel(`Count:${0}`));

        if (_cfunc.CommonPartyDropValue().value > 0) {
            setPartyDropdown(_cfunc.CommonPartyDropValue());
        }

        return () => {
            dispatch(commonPageFieldSuccess(null));
        };
    }, []);

    // 🟢 user access logic
    useEffect(() => {
        let userAcc = null;
        let locationPath = history.location.pathname;
        if (props.hasOwnProperty(mode.editValue)) {
            locationPath = props.masterPath;
        }
        userAcc = userAccess.find((inx) => `/${inx.ActualPagePath}` === locationPath);
        if (userAcc) {
            setUserAccState(userAcc);
            _cfunc.breadcrumbReturnFunc({ dispatch, userAcc });
        }
    }, [userAccess]);

    useEffect(() => {
        return () => {
            dispatch(Loyalty_Claim_GoButton_Success([]));
        };
    }, []);

    // 🟢 Excel mode
    useEffect(() => {
        if (Type === "downloadExcel") {
            const excelName = "Loyalty Claims";
            if (Data.length > 0) {
                const { columns, rows } = getTableConfig(selectedMode.value, Data);
                const excelData = rows.map((row) => {
                    const rowObj = {};
                    columns.forEach((col, i) => {
                        const value =
                            typeof row[i] === "object" && row[i]?.content !== undefined
                                ? row[i].content
                                : row[i] ?? "";
                        rowObj[col] = value;
                    });
                    return rowObj;
                });
                ExcelReportComponent({
                    pageField,
                    excelTableData: excelData,
                    excelFileName: excelName,
                });

                dispatch(Loyalty_Claim_GoButton_Success([]));
            }
        }
    }, [Type, Data, pageField, selectedMode]);


    useEffect(() => {
        try {
            if (tableData.Status === true && tableData.StatusCode === 200) {
                if (Type === "Print" || Type === "showOnTable") {
                    globalSelectedMonth = selectedMonth;
                    let config = { rowData: {} };
                    config.rowData["ReportType"] = report.LoyaltyClaimReport;
                    config.rowData["Status"] = tableData.Status;
                    config.rowData["StatusCode"] = tableData.StatusCode;
                    config.rowData["Data"] = tableData.Data; // ✅ your actual data array
                    config.rowData["Mode"] = selectedMode.value; // ✅ current mode
                    config.rowData["DateLabel"] = `Period: ${selectedMonth}`;
                    setLoyaltyReportMode(selectedMode.value);
                    dispatch(getpdfReportdataSuccess(config.rowData));
                    dispatch(Loyalty_Claim_GoButton_Success([]));
                }
            } else if (tableData.Status === true && tableData.StatusCode === 204) {
                customAlert({
                    Type: 3,
                    Message: tableData.Message,
                });
                dispatch(Loyalty_Claim_GoButton_Success([]));
                return;
            }
        } catch (e) {
            console.error("❌ PDF generation error:", e);
        }
    }, [tableData, Type, dispatch, values.FromDate, selectedMode]);

    // 🟢 Go button handler
    function goButtonHandler(BtnID) {
        try {
            if (!selectedMode || selectedMode.value === 0) {
                customAlert({
                    Type: 3,
                    Message: "Please select a report type before proceeding.",
                });
                return;
            }

            // 🔥 Convert month to From-To dates
            const { fromDate, toDate } = getMonthDateRange(selectedMonth);

            const jsonBody = JSON.stringify({
                FromDate: fromDate,
                ToDate: toDate,
                Party: PartyDropdown.value.toString(),
                Mode: selectedMode.value,
            });

            dispatch(Loyalty_Claim_Report_Action({ jsonBody, btnId: BtnID }));
        } catch (error) {
            _cfunc.CommonConsole(error);
        }
    }

    function getMonthDateRange(month) {
    const [year, mon] = month.split("-");
    const fromDate = `${year}-${mon}-01`;

    const lastDay = new Date(year, mon, 0).getDate(); // month end date
    const toDate = `${year}-${mon}-${String(lastDay).padStart(2, "0")}`;

    return { fromDate, toDate };
}

    const partyOnchange = (e) => {
        setPartyDropdown(e);
        dispatch(Loyalty_Claim_GoButton_Success([]));
    };

    const Party_Option = Distributor.map((i) => ({
        value: i.id,
        label: i.Name,
    }));

    Party_Option.unshift({
        value: 0,
        label: "All",
    });



    return (
        <React.Fragment>
            <MetaTags>{_cfunc.metaTagLabel(userPageAccessState)}</MetaTags>

            <div className="px-2 py-2 c_card_filter text-black">
                <Row className="align-items-center" style={{ marginLeft: "-10px" }}>
                    <Col sm="3">
                        <FormGroup className="row">
                            <Label className="col-sm-5 p-2" style={{ width: "50px" }}>
                                Month
                            </Label>
                            <Col sm="7">
                                <Input
                                    type="month"
                                    className="form-control"
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                    {/* 🟢 Party Dropdown */}
                    {isSCMParty && (
                        <Col sm="3">
                            <FormGroup className="row mb-0 align-items-center">
                                <Label className="col-sm-2 col-form-label">
                                    Party
                                </Label>
                                <Col sm="8">
                                    <Select
                                        name="Party"
                                        value={PartyDropdown}
                                        isSearchable
                                        isDisabled={Distributor.length === 0} // ✅ Disable if no list available
                                        classNamePrefix="dropdown"
                                        styles={{
                                            menu: (provided) => ({ ...provided, zIndex: 2 }),
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: "30px",
                                                backgroundColor: Distributor.length === 0 ? "#f3f3f3" : "white", // subtle visual cue
                                            }),
                                        }}
                                        options={
                                            Distributor.length > 0
                                                ? [
                                                    { value: 0, label: "All" },
                                                    ...Distributor.map((i) => ({
                                                        value: i.id,
                                                        label: i.Name,
                                                    })),
                                                ]
                                                : [
                                                    {
                                                        value: _cfunc.loginPartyID(),
                                                        label: _cfunc.loginPartyName(),
                                                    },
                                                ]
                                        }
                                        onChange={(e) => partyOnchange(e)}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    )}
                    {/* 🟢 Report Type Dropdown */}
                    <Col sm="3">
                        <FormGroup className="row mb-0 align-items-center">
                            <Label className="col-sm-4 col-form-label" style={{ paddingLeft: "28px" }}>
                                Report Type
                            </Label>
                            <Col sm="8">
                                <Select
                                    options={[
                                        { value: 1, label: "Loyalty Points Redemption Claim" },
                                        { value: 2, label: "Loyalty Points Redemption Claim CBM Summary Report" },
                                        { value: 3, label: "Loyalty Coupon Claim" },
                                    ]}
                                    value={selectedMode}
                                    onChange={(selected) => {
                                        setSelectedMode(selected);
                                        setLoyaltyReportMode(selected.value);
                                    }}
                                    isSearchable
                                    classNamePrefix="dropdown"
                                    styles={{
                                        menu: (provided) => ({ ...provided, zIndex: 2 }),
                                        control: (provided) => ({ ...provided, minHeight: "30px" }),
                                    }}
                                />
                            </Col>
                        </FormGroup>
                    </Col>

                    {/* 🟢 Print Button */}
                    <Col sm="3" className="d-flex justify-content-end align-items-center">
                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={GoBtnLoading === "Print"}
                            className="btn btn-success"
                            onClick={() => goButtonHandler("Print")}
                        >
                            Print
                        </C_Button>
                        <C_Button
                            type="button"
                            spinnerColor="white"
                            loading={GoBtnLoading === "downloadExcel"}
                            className="btn btn-primary m-3 mr"
                            onClick={() => goButtonHandler("downloadExcel")}
                        >
                            Excel
                        </C_Button>
                    </Col>
                </Row>
            </div>

            <C_Report />
        </React.Fragment>

    );
};

export default LoyaltyClaim;
